<div class="flex-center-center pt-3 warranty-terms-policy px-3">
    <div class="br-3 p-3 policy-page-layout width-75p" *ngIf="!isLoading">

        <!-- hedaer section -->
        <div class="company-header flex-column gap-10px border-bottom-primary pb-1">
            <div class="flex-row">
                <!-- address section -->
                <div class="flex-between-start w-100">
                    <div class="company-addrerss flex-row gap-10px">
                        <div class="company-logo" *ngIf="company?.pdfLogo">
                            <img [ngClass]="pdfLogoType" class="company-logo" [src]="company?.pdfLogo"
                                [alt]="company?.name" />
                        </div>
                        <div class="company-logo" *ngIf="!company?.pdfLogo">
                            <img class="company-logo" [src]="company?.logo" [alt]="company?.name" />
                        </div>
                        <div class="address-details flex-column">
                            <span class="font-bold">{{ company?.name }}</span>
                            <span class="font-12">{{ company?.phone | mask : '(000) 000-0000' }}</span>
                            <span class="font-12">{{ company?.email }}</span>
                            <span class="font-12">{{ company.formattedAdress }}</span>
                            <span class="font-12" *ngIf="company.regNumber && company.regNumber.includes(':')"
                                [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)">
                            </span>
                            <span class="font-12" *ngIf="company.regNumber && !company.regNumber.includes(':')">
                                Business/GST#: {{ company?.regNumber }}</span>
                        </div>
                    </div>

                    <div class="invoice-info flex-column">
                        <span class="font-bold font-16">{{'limited-warranty-terms'|translate}}</span>
                        <span class="font-12">{{ order?.createdAt | date : 'MMM d, y h:mm a' }}</span>
                        <span class="font-12">{{'invoice.service-advisor' | translate}}: {{ order.serviceWriter &&
                            order.serviceWriter.name }}</span>
                    </div>
                </div>



            </div>
            <div class="flex-row">
                <!-- serviceAdvisor section -->
                <div class="flex-between-start w-100">
                    <div class="advisor-details flex-column">
                        <span class="font-bold capitalize">{{ customer?.fullName }}</span>
                        <span class="font-12">{{ customer?.phone | mask : '(000) 000-0000' }}</span>
                        <span class="font-12">{{ customer?.email }}</span>
                    </div>



                    <div class="vehicle-details flex-column">
                        <span class="font-bold">{{ vehicle?.vehicleName ? vehicle?.vehicleName : vehicle?.name }}</span>
                        <span>{{'invoice.VIN' | translate}}: <span
                                [innerHTML]="vehicle?.VIN | highlightVin"></span></span>
                        <span class="font-12">{{'invoice.mileage' | translate}}: {{ mileageOut?.reading || 0 }}
                            &nbsp;<span *ngIf="mileageOut?.mileageMeasuringUnit">{{mileageOut?.mileageMeasuringUnit ===
                                'mi' ? 'miles' : 'km' }}</span>
                        </span>
                        <span class="font-12">{{'invoice.license-plate' | translate}}: {{ vehicle?.licensePlateNo
                            }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- warranty disclaimber body -->
        <div class="policy-disclaimer-body mt-3">
            <div [innerHTML]="warrantyDisclaimer"></div>
        </div>
    </div>
    <div *ngIf="isLoading" class="text-center">
        <p class="mt-5 font-600 font-16">Loading...
        <p>
    </div>
</div>

<div class="flex-center-center pt-3 warranty-terms-policy pb-3" *ngIf="tireWarrantyPolicy">
    <div class="br-3 p-5 policy-page-layout width-75p" *ngIf="!isLoading">

        <!-- hedaer section -->
        <div class="company-header flex-column gap-10px border-bottom-primary pb-1">
            <div class="flex-row">
                <!-- address section -->
                <div class="flex-between-start w-100">
                    <div class="company-addrerss flex-row gap-10px">
                        <div class="company-logo" *ngIf="company?.pdfLogo">
                            <img [ngClass]="pdfLogoType" class="company-logo" [src]="company?.pdfLogo"
                                [alt]="company?.name" />
                        </div>
                        <div class="company-logo" *ngIf="!company?.pdfLogo">
                            <img class="company-logo" [src]="company?.logo" [alt]="company?.name" />
                        </div>
                        <div class="address-details flex-column">
                            <span class="font-bold">{{ company?.name }}</span>
                            <span class="font-12">{{ company?.phone | mask : '(000) 000-0000' }}</span>
                            <span class="font-12">{{ company?.email }}</span>
                            <span class="font-12">{{ company.formattedAdress }}</span>
                            <span class="font-12" *ngIf="company.regNumber && company.regNumber.includes(':')"
                                [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)">
                            </span>
                            <span class="font-12" *ngIf="company.regNumber && !company.regNumber.includes(':')">
                                Business/GST#: {{ company?.regNumber }}</span>
                        </div>
                    </div>

                    <div class="invoice-info flex-column">
                        <span class="font-bold font-16">{{'limited-warranty-terms'|translate}}</span>
                        <span class="font-12">{{ order?.createdAt | date : 'MMM d, y h:mm a' }}</span>
                        <span class="font-12">{{'invoice.service-advisor' | translate}}: {{ order.serviceWriter &&
                            order.serviceWriter.name }}</span>
                    </div>
                </div>



            </div>
            <div class="flex-row">
                <!-- serviceAdvisor section -->
                <div class="flex-between-start w-100">
                    <div class="advisor-details flex-column">
                        <span class="font-bold capitalize">{{ customer?.fullName }}</span>
                        <span class="font-12">{{ customer?.phone | mask : '(000) 000-0000' }}</span>
                        <span class="font-12">{{ customer?.email }}</span>
                    </div>



                    <div class="vehicle-details flex-column">
                        <span class="font-bold">{{ vehicle?.vehicleName ? vehicle?.vehicleName : vehicle?.name }}</span>
                        <span>{{'invoice.VIN' | translate}}: <span
                                [innerHTML]="vehicle?.VIN | highlightVin"></span></span>
                        <span class="font-12">{{'invoice.mileage' | translate}}: {{ mileageOut?.reading || 0 }}
                            &nbsp;<span *ngIf="mileageOut?.mileageMeasuringUnit">{{mileageOut?.mileageMeasuringUnit ===
                                'mi' ? 'miles' : 'km' }}</span>
                        </span>
                        <span class="font-12">{{'invoice.license-plate' | translate}}: {{ vehicle?.licensePlateNo
                            }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="tw-container">
            <div class="tw-header">
                {{ currentLang == 'en' ?
                'Congratulations! Your new tire purchase includes the Golden Guarantee!'
                : 'Félicitations! L\'achat de vos nouveaux pneus comprend la Garantie Or!'
                }}
            </div>
            <div class="tw-grid">
                <ng-container *ngFor="let tire of warrantiedTires">
                    <div class="tw-grid-item">
                      <p>{{ tire?.brand?.name || 'N/A'  }} {{ tire?.model || 'N/A'  }}</p>
                      <p>{{ tire?.category?.name || tire?.category?.categoryName || 'N/A'  }}</p>
                      <p>{{ tire?.size || 'N/A'  }}</p>
                      <p>DOT: {{ tire.dotNumber || 'N/A'}}</p>
                      <p>Part#: {{ tire?.code || 'N/A'  }}</p>
                      <p>Warranty#: {{ tire?.warranty?.warrantyNumber || 'N/A' }}</p>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- Tire Warranty Policy-->
        <div class="policy-disclaimer-body mt-3">
            <div [innerHTML]="tireWarrantyPolicy"></div>
        </div>
    </div>
    <div *ngIf="isLoading" class="text-center">
        <p class="mt-5 font-600 font-16">Loading...
        <p>
    </div>
</div>
